<template>
  <v-app style="background-color: #f8f9fb">
    <v-dialog v-model="remetenteDialog" max-width="1000px" persistent>
      <v-card class="elevation-3 rounded-lg">
        <!-- Cabeçalho -->
        <v-card-title
          class="headline white--text primary justify-center py-4 rounded-t-lg"
        >
          <v-icon left class="mr-2">mdi-account-multiple</v-icon>
          Selecionar Remetentes
        </v-card-title>

        <!-- Conteúdo principal -->
        <v-card-text
          class="py-4 px-4"
          style="min-height: 400px; background-color: #f9f9f9"
        >
          <!-- Select para escolha do grupo -->
          <v-select
            v-model="grupoSelecionado"
            :items="opcoesGrupos"
            item-text="nome"
            item-value="id"
            label="Selecione um grupo"
            outlined
            dense
            hide-details
            class="mb-4"
            return-object
          >
            <template v-slot:selection="{ item }">
              <span>{{ item.nome }}</span>
              <span v-if="item.id !== 'todos'" class="grey--text ml-2">
                ({{ item.colaboradores?.length || 0 }} colaboradores)
              </span>
              <span v-else class="grey--text ml-2">
                ({{ listaColaboradores.length || 0 }} colaboradores)
              </span>
            </template>
            <template v-slot:item="{ item }">
              <span>{{ item.nome }}</span>
              <span v-if="item.id !== 'todos'" class="grey--text ml-2">
                ({{ item.colaboradores?.length || 0 }} colaboradores)
              </span>
              <span v-else class="grey--text ml-2">
                ({{ listaColaboradores.length || 0 }} colaboradores)
              </span>
            </template>
          </v-select>

          <!-- Tabela de colaboradores do grupo selecionado -->
          <div v-if="grupoSelecionado" class="mt-8">
            <v-row>
              <v-col cols="6" md="6"></v-col>
              <v-col cols="6" md="6" class="d-flex justify-end py-0">
                <v-text-field
                  v-model="search"
                  label="Buscar colaborador"
                  append-icon="mdi-magnify"
                  dense
                  hide-details
                  outlined
                  class="mb-2"
                />
              </v-col>
              <v-col cols="12" class="py-0">
                <v-data-table
                  :headers="headersColaboradores"
                  :items="tabelaColaboradores"
                  :search="search"
                  item-key="id"
                  fixed-header
                  show-select
                  v-model="colaboradoresSelecionados"
                  dense
                  class="elevation-0 rounded"
                  :items-per-page="10"
                  height="40vh"
                >
                  <template v-slot:no-data>
                    <v-alert
                      type="info"
                      class="text-center py-2 my-4"
                      height="50px"
                    >
                      Nenhum colaborador encontrado.
                    </v-alert>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </div>
          <div v-else class="text-center py-8">
            <v-icon size="64" color="grey lighten-1">mdi-account-group</v-icon>
            <div class="grey--text mt-4">
              Selecione um grupo para visualizar os colaboradores
            </div>
          </div>
        </v-card-text>

        <!-- Rodapé -->
        <v-card-actions class="px-4 pb-4">
          <v-spacer />
          <v-btn
            color="primary"
            @click="
              remetenteDialog = false;
              search = '';
              grupoSelecionado = null;
            "
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container
      style="background-color: #eee"
      id="financeiro"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-link-variant"
            title="Comunicação Interna"
            color="rgb(71 130 180)"
            style="margin-top: 60px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <v-form ref="form" v-model="valid">
              <v-row style="margin-top: 1rem">
                <v-col cols="6" class="py-0">
                  <span>Forma de Disparo</span>
                  <!-- Ativar a Data Final -->
                  <v-select
                    :items="['SMS', 'WhatsApp']"
                    v-model="regra.formadisparo"
                    label="Forma de disparo"
                    dense
                    solo-inverted
                    required
                    :rules="[
                      (v) =>
                        (v != null && v !== '') || 'Este campo é obrigatório',
                    ]"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="py-0">
                  <span>Empresa</span>
                  <v-select
                    v-model="regra.empresa"
                    :items="filteredEmpresas"
                    label="Empresa"
                    dense
                    required
                    :rules="[
                      (v) =>
                        (v != null && v !== '') || 'Este campo é obrigatório',
                    ]"
                    solo-inverted
                  ></v-select>
                </v-col>
                <!-- Mensagem para Disparo -->
                <v-col
                  cols="12"
                  class="py-0"
                  v-if="regra.formadisparo === 'SMS'"
                >
                  <div class="d-flex align-center mb-1">
                    <span>Mensagem para Disparo</span>
                    <v-spacer></v-spacer>
                    <div class="text-formatting-buttons d-flex align-center">
                      <v-btn-toggle dense group class="elevation-0 rounded-lg mr-2">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              small
                              text
                              @click="formatar('bold')"
                              v-on="on"
                              class="px-1"
                            >
                              <v-icon small>mdi-format-bold</v-icon>
                            </v-btn>
                          </template>
                          <span>Negrito</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              small
                              text
                              @click="formatar('italic')"
                              v-on="on"
                              class="px-1"
                            >
                              <v-icon small>mdi-format-italic</v-icon>
                            </v-btn>
                          </template>
                          <span>Itálico</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              small
                              text
                              @click="formatar('underline')"
                              v-on="on"
                              class="px-1"
                            >
                              <v-icon small>mdi-format-underline</v-icon>
                            </v-btn>
                          </template>
                          <span>Sublinhado</span>
                        </v-tooltip>
                      </v-btn-toggle>
                      <v-menu
                        v-model="showEmojiPicker"
                        :close-on-content-click="false"
                        :nudge-width="200"
                        offset-y
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            small
                            text
                            v-bind="attrs"
                            v-on="on"
                            class="px-1"
                            @click="toggleEmojiPicker"
                          >
                            <v-icon small>mdi-emoticon-outline</v-icon>
                          </v-btn>
                        </template>
                        <div class="emoji-picker-container">
                          <emoji-picker
                            @emoji-click="onEmojiClick"
                            class="light"
                          ></emoji-picker>
                        </div>
                      </v-menu>
                    </div>
                  </div>
                  <v-textarea
                  dense
                    solo-inverted
                    label="Mensagem para Disparo"
                    auto-grow
                    rows="3"
                    max-length="160"
                    :counter="160"
                    :rules="[
                      (v) => (v && v.length <= 160) || 'Mensagem muito longa',
                    ]"
                    v-model="regra.mensagem"
                    ref="mensagemTextareaSMS"
                  />

                  <!-- <v-text
                    class="text-primary text-decoration-underline"
                    @click="dialog = true"
                    style="cursor: pointer"
                  >
                    Variáveis disponíveis
                  </v-text> -->
                </v-col>
                <v-col
                  cols="12"
                  class="py-0"
                  v-if="regra.formadisparo === 'WhatsApp'"
                >
                  <div class="d-flex align-center mb-1">
                    <span>Mensagem para Disparo</span>
                    <v-spacer></v-spacer>
                    <div class="text-formatting-buttons d-flex align-center">
                      <v-btn-toggle dense group class="elevation-0 rounded-lg mr-2">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              small
                              text
                              @click="formatar('bold')"
                              v-on="on"
                              class="px-1"
                            >
                              <v-icon small>mdi-format-bold</v-icon>
                            </v-btn>
                          </template>
                          <span>Negrito</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              small
                              text
                              @click="formatar('italic')"
                              v-on="on"
                              class="px-1"
                            >
                              <v-icon small>mdi-format-italic</v-icon>
                            </v-btn>
                          </template>
                          <span>Itálico</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              small
                              text
                              @click="formatar('underline')"
                              v-on="on"
                              class="px-1"
                            >
                              <v-icon small>mdi-format-underline</v-icon>
                            </v-btn>
                          </template>
                          <span>Sublinhado</span>
                        </v-tooltip>
                      </v-btn-toggle>
                      <v-menu
                        v-model="showEmojiPicker"
                        :close-on-content-click="false"
                        :nudge-width="200"
                        offset-y
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            small
                            text
                            v-bind="attrs"
                            v-on="on"
                            class="px-1"
                            @click="toggleEmojiPicker"
                          >
                            <v-icon small>mdi-emoticon-outline</v-icon>
                          </v-btn>
                        </template>
                        <div class="emoji-picker-container">
                          <emoji-picker
                            @emoji-click="onEmojiClick"
                            class="light"
                          ></emoji-picker>
                        </div>
                      </v-menu>
                    </div>
                  </div>
                  <v-textarea
                  dense
                  solo-inverted
                    label="Mensagem para Disparo"
                    auto-grow
                    rows="4"
                    max-length="1000"
                    :counter="1000"
                    :rules="[
                      (v) => (v && v.length <= 1000) || 'Mensagem muito longa',
                    ]"
                    v-model="regra.mensagem"
                    ref="mensagemTextareaWhatsApp"
                  />

                  <!-- <v-text
                    class="text-primary text-decoration-underline"
                    @click="dialog = true"
                    style="cursor: pointer"
                  >
                    Variáveis disponíveis
                  </v-text> -->
                </v-col>

                <v-col
                  cols="6"
                  class="pt-0"
                  v-if="regra.formadisparo === 'WhatsApp'"
                >
                  <span>Arquivo Anexado</span>
                  <!-- Exibir preview se for um link existente -->
                  <div v-if="isExistingAttachment" class="mb-2">
                    <v-card outlined class="pa-2 mt-0">
                      <div class="d-flex align-center">
                        <v-icon class="mr-2">mdi-attachment</v-icon>
                        <div class="text-truncate flex-grow-1">
                          Anexo existente
                        </div>
                        <v-btn icon small @click="visualizarAnexo" class="mr-2">
                          <v-icon small>mdi-eye</v-icon>
                        </v-btn>
                        <v-btn icon small @click="removerAnexoExistente">
                          <v-icon small>mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </v-card>
                  </div>
                  <!-- Input de arquivo normal se não houver anexo existente ou se foi removido -->
                  <v-file-input
                    v-if="!isExistingAttachment"
                    counter
                    dense
                    solo-inverted
                    show-size
                    v-model="regra.anexos"
                    :accept="'image/*, video/*'"
                    truncate-length="45"
                    :rules="[
                      (v) =>
                        !v ||
                        v.size < 60000000 ||
                        'O arquivo deve ter menos de 60MB',
                    ]"
                  ></v-file-input>
                </v-col>
                <!-- <v-col
                  cols="6"
                  class="pt-0"
                  v-if="regra.formadisparo === 'WhatsApp'"
                >
                  <span>Contato Destino</span>
                  <v-select
                    dense
                    solo-inverted
                    :items="['PREVIDA', 'PARQUE DAS FLORES', 'MEMORIAL']"
                    truncate-length="45"
                    :rules="[
                      (v) =>
                        !v ||
                        v.size < 60000000 ||
                        'O arquivo deve ter menos de 60MB',
                    ]"
                  ></v-select>
                </v-col> -->
              </v-row>

              <v-row>
                <!-- Horário -->
                <v-col cols="4" sm="2" class="py-0">
                  <span>Horário</span>
                  <v-text-field
                    dense
                    solo-inverted
                    v-model="regra.horario"
                    label="Horário"
                    type="time"
                    :rules="[(v) => !!v || 'Este campo é obrigatório']"
                  ></v-text-field>
                </v-col>
                <!-- Data Inicial -->
                <v-col cols="6" sm="2" class="py-0">
                  <span>Data Inicial</span>
                  <v-menu
                    v-model="isStartDatePickerOpen"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    bottom
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        v-model="regra.data_inicial"
                        label="Data Inicial"
                        dense
                        solo-inverted
                        readonly
                        required
                        :rules="[
                          (v) =>
                            (v != null && v !== '') ||
                            'Este campo é obrigatório',
                        ]"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      no-title
                      v-model="localSelectedStartDateISO"
                      @input="handleStartDateSelection"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <!-- Data Final -->
                <v-col cols="12" sm="2" class="py-0" v-if="regra.indeterminate">
                  <span>Data Final</span>
                  <v-menu
                    v-model="isEndDatePickerOpen"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    bottom
                  >
                    <template #activator="{ on }">
                      <v-text-field
                        v-model="regra.data_final"
                        label="Data Final"
                        dense
                        solo-inverted
                        readonly
                        v-on="on"
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      no-title
                      v-model="localSelectedEndDateISO"
                      @input="handleEndDateSelection"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="2" class="d-flex align-center py-0">
                  <!-- Ativar a Data Final -->
                  <v-switch
                    color="blue"
                    v-model="regra.indeterminate"
                    label="Recorrência"
                    class="mt-0"
                    inset
                    hide-details
                  ></v-switch>
                </v-col>

                <v-col cols="4" class="d-flex align-center py-0">
                  <!-- Ativar a Data Final -->
                  <v-switch
                    color="blue"
                    inset
                    v-model="regra.status"
                    label="Status da Regra"
                    class="mt-0"
                    hide-details
                  ></v-switch>
                </v-col>
              </v-row>

              <v-row class="mb-8" v-if="regra.formadisparo === 'WhatsApp'">
                <v-col cols="12" sm="12" class="py-0 mb-4">
                  <span>Adicionar botões</span>
                  <v-switch
                    v-model="showBotoes"
                    color="primary"
                    hide-details
                    class="mt-2"
                    inset
                  ></v-switch>
                </v-col>
                <!-- Botão 1 -->
                <v-col cols="12" sm="4" class="py-0" v-if="showBotoes">
                  <span>Botão 1</span>
                  <v-text-field
                    v-model="regra.labelBotao1"
                    label="Texto do Botão 1"
                    dense
                    solo-inverted
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" class="py-0" v-if="showBotoes">
                  <span>Tipo Botão 1</span>
                  <v-select
                    v-model="regra.tipoBotao1"
                    :items="['CALL', 'URL', 'REPLY']"
                    label="Tipo"
                    dense
                    solo-inverted
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="4" class="py-0" v-if="showBotoes">
                  <span>Link/Valor Botão 1</span>
                  <v-text-field
                    v-model="regra.linkBotao1"
                    label="Link ou valor"
                    dense
                    solo-inverted
                    :disabled="regra.tipoBotao1 === 'REPLY'"
                  ></v-text-field>
                </v-col>

                <!-- Botão 2 -->
                <v-col cols="12" sm="4" class="py-0" v-if="showBotoes">
                  <span>Botão 2</span>
                  <v-text-field
                    v-model="regra.labelBotao2"
                    label="Texto do Botão 2"
                    dense
                    solo-inverted
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" class="py-0" v-if="showBotoes">
                  <span>Tipo Botão 2</span>
                  <v-select
                    v-model="regra.tipoBotao2"
                    :items="['CALL', 'URL', 'REPLY']"
                    label="Tipo"
                    dense
                    solo-inverted
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="4" class="py-0" v-if="showBotoes">
                  <span>Link/Valor Botão 2</span>
                  <v-text-field
                    v-model="regra.linkBotao2"
                    label="Link ou valor"
                    dense
                    solo-inverted
                    :disabled="regra.tipoBotao2 === 'REPLY'"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" class="py-0" v-if="showBotoes">
                  <span>Botão 3</span>
                  <v-text-field
                    v-model="regra.labelBotao3"
                    label="Texto do Botão 3"
                    dense
                    solo-inverted
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" class="py-0" v-if="showBotoes">
                  <span>Tipo Botão 3</span>
                  <v-select
                    v-model="regra.tipoBotao3"
                    :items="['CALL', 'URL', 'REPLY']"
                    label="Tipo"
                    dense
                    solo-inverted
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="4" class="py-0" v-if="showBotoes">
                  <span>Link/Valor Botão 3</span>
                  <v-text-field
                    v-model="regra.linkBotao3"
                    label="Link ou valor"
                    dense
                    solo-inverted
                    :disabled="regra.tipoBotao3 === 'REPLY'"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" class="py-0" v-if="showBotoes">
                  <span>Botão 4</span>
                  <v-text-field
                    v-model="regra.labelBotao4"
                    label="Texto do Botão 4"
                    dense
                    solo-inverted
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" class="py-0" v-if="showBotoes">
                  <span>Tipo Botão 4</span>
                  <v-select
                    v-model="regra.tipoBotao4"
                    :items="['CALL', 'URL', 'REPLY']"
                    label="Tipo"
                    dense
                    solo-inverted
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="4" class="py-0" v-if="showBotoes">
                  <span>Link/Valor Botão 4</span>
                  <v-text-field
                    v-model="regra.linkBotao4"
                    label="Link ou valor"
                    dense
                    solo-inverted
                    :disabled="regra.tipoBotao4 === 'REPLY'"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-card
                class="mb-6 card-section"
                outlined
                elevation="0"
                v-if="regra.formadisparo !== ''"
              >
                <v-card-title class="section-header">
                  <v-row style="width: 100%">
                    <v-col cols="10">
                      <v-icon color="green" class="mr-2"
                        >mdi-account-multiple</v-icon
                      >
                      Lista de Remetentes
                      <v-chip
                        class="ml-2"
                        small
                        color="primary"
                        text-color="white"
                        >{{ colaboradoresSelecionados.length }}</v-chip
                      >
                    </v-col>
                    <v-col cols="2" class="d-flex align-end justify-end">
                      <v-btn
                        small
                        color="primary"
                        @click="remetenteDialog = true"
                      >
                        <v-icon color="white" left>mdi-plus</v-icon>
                        Adicionar remetente
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-divider></v-divider>
                <!-- Lista de permissões -->
                <v-card-text class="py-0">
                  <v-list dense v-if="colaboradoresSelecionados.length > 0">
                    <v-list-item
                      v-for="(item, index) in paginatedRemetentes"
                      :key="item.id || index"
                    >
                      <v-list-item-avatar>
                        <v-icon>mdi-account</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-chip small color="secondary" text-color="white">
                            Colaborador
                          </v-chip>
                        </v-list-item-title>
                        <v-list-item-title>
                          Nome: {{ truncate(item?.nome, 20) }}, Empresa:
                          {{ item?.empresa }}, Cargo: {{ item?.cargo }},
                          Telefone: {{ item?.telefone }}
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn
                          text
                          small
                          @click="removerColaboradorSelecionado(index)"
                        >
                          <v-icon color="red">mdi-delete</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                  <v-pagination
                    v-if="colaboradoresSelecionados.length > 5"
                    v-model="remetentePage"
                    :length="Math.ceil(colaboradoresSelecionados.length / 5)"
                    class="my-4"
                    color="primary"
                    :total-visible="7"
                  />
                  <div
                    v-if="colaboradoresSelecionados.length === 0"
                    class="text-center py-4"
                  >
                    Nenhum remetente adicionado.
                  </div>
                </v-card-text>
              </v-card>
              <v-card-actions class="d-flex justify-end">
                <v-btn
                  outlined
                  small
                  v-if="!showEditar"
                  color="primary"
                  :disabled="loadingCreate"
                  @click="clear_atualizacao()"
                >
                  <v-icon left>mdi-reload</v-icon>Limpar formulário
                </v-btn>
                <v-btn
                  small
                  v-if="!showEditar"
                  :loading="loadingCreate"
                  color="primary"
                  @click="adiciona_regra()"
                  class="pr-4"
                  :disabled="!valid || colaboradoresSelecionados.length === 0"
                >
                  <v-icon left>mdi-plus</v-icon>Novo disparo
                </v-btn>
                <v-btn
                  outlined
                  small
                  v-if="showEditar"
                  color="red"
                  @click="clear_atualizacao()"
                >
                  <v-icon left>mdi-cancel</v-icon>Cancelar Edição
                </v-btn>
                <v-btn
                  small
                  v-if="showEditar"
                  :loading="loadingUpdate"
                  color="warning"
                  @click="atualizar_regra(regra)"
                  class="mr-0"
                >
                  <v-icon left>mdi-update</v-icon>Atualizar Regra
                </v-btn>
              </v-card-actions>
            </v-form>

            <v-data-table
              style="margin-top: 1rem"
              :headers="ranking_header"
              :items="listaRegras"
              :items-per-page="50"
              items-per-page-text="Linhas por página"
              class="elevation-0"
            >
              <br />
              <br />
              <br />
              <template v-slot:top>
                <v-progress-linear
                  v-if="isLoading"
                  indeterminate
                  color="rgb(71 130 180)"
                ></v-progress-linear>
              </template>
              <template v-slot:item="row">
                <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                  <td class="linha">
                    {{ row.item.mensageria.id }}
                  </td>
                  <td class="linha">
                    {{ truncate(row.item.mensageria.mensagem, 60) }}
                  </td>
                  <td class="linha">
                    {{ row.item.mensageria_colaborador?.forma_disparo }}
                  </td>

                  <td class="linha">
                    {{
                      row.item.mensageria_colaborador
                        ?.mensageria_colaborador_pessoa.length
                    }}
                  </td>

                  <td class="linha">
                    {{ row.item.mensageria.data_inicial }}
                  </td>

                  <td class="linha">
                    {{ row.item.mensageria.horario }}
                  </td>
                  <td class="linha">
                    <v-chip
                      :color="getStatusDisparoCor(row.item.mensageria.status)"
                      text-color="white"
                    >
                      {{ getStatus(row.item.mensageria.status) }}
                    </v-chip>
                  </td>
                  <td class="linha">
                    <v-btn
                      @click="editarRegra(row.item)"
                      text
                      small
                      color="warning"
                    >
                      <v-icon dark> mdi-pencil </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialog" max-width="800px">
        <v-card>
          <v-card-title class="headline">Variáveis Disponíveis</v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="variaveis"
              dense
              hide-default-footer
            >
              <template v-slot:item="row">
                <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                  <!-- Nome da variável + Botão Copiar -->
                  <td class="linha" style="width: 20%">
                    <div class="d-flex align-center">
                      <code>{{ row.item.nome }}</code>
                      <v-spacer></v-spacer>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            small
                            v-bind="attrs"
                            v-on="on"
                            @click="copiarTexto(row.item.nome)"
                          >
                            <v-icon size="17" center>mdi-content-copy</v-icon>
                          </v-btn>
                        </template>
                        <span>Copiar</span>
                      </v-tooltip>
                    </div>
                  </td>

                  <!-- Descrição -->
                  <td class="linha" style="width: 20%">
                    <v-chip small color="blue lighten-4">{{
                      row.item.descricao
                    }}</v-chip>
                  </td>

                  <!-- Exemplo -->
                  <td class="linha" style="width: 30%">
                    <p
                      class="text-body-2 text-grey-darken-1"
                      style="max-width: 100%"
                    >
                      {{ row.item.exemplo }}
                    </p>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" outlined small @click="dialog = false">
              <v-icon left>mdi-close</v-icon>Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-app>
</template>
<script>
import { ContentLoader } from "vue-content-loader";
import VuetifyMoney from "./components/VuetifyMoney.vue";
import mensageria from "../../services/mensageria";
import rh from "../../services/rh";

// Carregamento do emoji-picker
let emojiPickerLoaded = false;

async function loadEmojiPicker() {
  if (!emojiPickerLoaded) {
    await import("emoji-picker-element");
    emojiPickerLoaded = true;
  }
}

export default {
  name: "MensageriaCobranca",
  components: {
    apexcharts: ContentLoader,
    "vuetify-money": VuetifyMoney,
  },

  created() {},

  mounted() {
    this.consultar_regras();
    this.consultar_grupo_colaboradores();
    this.consultar_colaboradores();
  },

  computed: {
    filteredEmpresas() {
      return this.empresas.filter((empresa) => this.hasPermission(empresa));
    },
    opcoesGrupos() {
      // Adiciona a opção "Todos colaboradores" no início da lista
      const todosOption = {
        id: "todos",
        nome: "Todos colaboradores",
      };

      // Mapeia os grupos para o formato esperado pelo select
      const grupos = this.listaGruposColaborador.map((grupo) => ({
        id: grupo.grupo.id,
        nome: grupo.grupo.nome,
        colaboradores: grupo.colaboradores,
      }));

      // Retorna a lista com a opção "Todos" no início
      return [todosOption, ...grupos];
    },

    tabelaColaboradores() {
      // Se a opção selecionada for "Todos colaboradores", retorna a lista completa
      if (this.grupoSelecionado && this.grupoSelecionado.id === "todos") {
        return this.listaColaboradores;
      }

      // Caso contrário, retorna os colaboradores do grupo selecionado
      return this.grupoSelecionado?.colaboradores || [];
    },

    paginatedRemetentes() {
      const start = (this.remetentePage - 1) * 5;
      const end = start + 5;
      return this.colaboradoresSelecionados.slice(start, end);
    },
    tipoRegra() {
      return this.regra.status;
    },
    filteredEmpresas() {
      return this.empresas.filter((empresa) => this.hasPermission(empresa));
    },
    mensagemRealLength() {
      let mensagem = this.regra.mensagem || "";
      let length = mensagem.length;

      this.variaveis.forEach((v) => {
        const regex = new RegExp(v.nome, "g");
        const ocorrencias = (mensagem.match(regex) || []).length;

        // Subtrai o tamanho da variável e soma o tamanho do valor real (tamanho definido)
        length += ocorrencias * (v.tamanho - v.nome.length);
      });

      return length;
    },
  },

  data() {
    return {
      isExistingAttachment: false,
      existingAttachmentUrl: null,
      remetenteDialog: false,
      remetentePage: 1,
      showBotoes: false,
      grupoSelecionado: null,
      headersColaboradores: [
        { text: "Nome", value: "nome" },
        { text: "Empresa", value: "empresa" },
        { text: "Telefone", value: "telefone" },
        { text: "Departamento", value: "departamento" },
      ],
      search: "",
      colaboradoresSelecionados: [],
      variaveis: [
        {
          nome: "{{contrato}}",
          descricao: "Contrato do Cliente",
          exemplo: "MP012234",
          tamanho: 9,
        },
        {
          nome: "{{identificacao}}",
          descricao: "Identificação Fatura",
          exemplo: "03/25",
          tamanho: 5,
        },
        {
          nome: "{{vencimento}}",
          descricao: "Data de Vencimento",
          exemplo: "25/03/2025",
          tamanho: 10,
        },
        {
          nome: "{{codigobarras}}",
          descricao: "Código de Barras",
          exemplo: "23793.04708  90001.196063  11022.795709  8  99220000000500",
          tamanho: 58,
        },
      ],
      headers: [
        { text: "Variável", value: "nome" },
        { text: "Descrição", value: "descricao" },
        { text: "Exemplo", value: "exemplo" },
      ],
      loadingCreate: false,
      loadingUpdate: false,
      valid: false,
      dialog: false,
      showEditar: false,
      // Emoji picker
      showEmojiPicker: false,
      listaRegras: [],
      listaGruposColaborador: [],
      valid: false,
      regra: {
        id: 0,
        grupos: [],
        horario: "",
        data_inicial: "",
        data_final: "",
        indeterminate: false,
        mensagem: "",
        status: true,
        empresa: "",
        formadisparo: "",
        idMensageria: 0,
      },
      isStartDatePickerOpen: false,
      isEndDatePickerOpen: false,
      localSelectedStartDateISO: "",
      localSelectedEndDateISO: "",
      ranking_header: [
        { text: "#", value: "ID", width: "70px" },
        { text: "Mensagem Disparo", value: "mensagem" },
        { text: "Forma disparo", value: "forma_disparo" },
        {
          text: "Quantidade Remetentes",
          value: "mensageria_colaborador_pessoa",
        },
        { text: "Data Inicial", value: "data_inicial" },
        { text: "Horário disparo", value: "horario" },
        { text: "Status", value: "status" },
        { text: "Ações", value: "acao" },
      ],
      isLoading: false,
      empresas: [
        "CEMITERIO PREVIDA",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DAS FLORES",
        "PARQUE DO AGRESTE",
        "PREVIDA",
        "A FLOR DO CAFÉ",
        "CEMITERIO PREVIDA SAO MIGUEL",
      ],
      listaColaboradores: [],
    };
  },

  methods: {
    hasPermission(empresa) {
      this.user = JSON.parse(sessionStorage.getItem("user"));

      if (this.user.roles.includes("ROLE_ADMIN")) {
        return true;
      } else if (empresa === "Todas") {
        return true;
      } else {
        const requiredRoles = empresa
          .split(",")
          .map(
            (name) => "ROLE_" + name.trim().toUpperCase().replace(/\s/g, "_")
          );

        const hasAnyRequiredRole = requiredRoles.some((role) =>
          this.user.roles.includes(role)
        );
        return hasAnyRequiredRole;
      }
    },
    visualizarAnexo() {
      if (this.existingAttachmentUrl) {
        window.open(this.existingAttachmentUrl, "_blank");
      }
    },

    removerAnexoExistente() {
      this.isExistingAttachment = false;
      this.existingAttachmentUrl = null;
      this.regra.anexos = null;
    },
    consultar_colaboradores() {
      rh.lista_colaboradores_ativos()
        .then((response) => {
          this.listaColaboradores = response.data;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {});
    },
    async fileToBase64(file) {
      return new Promise((resolve, reject) => {
        if (!file) {
          resolve(null);
          return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          // Remove o prefixo (ex: "data:application/pdf;base64,") para obter apenas o base64
          const base64String = reader.result.split(",")[1];
          resolve(base64String);
        };
        reader.onerror = (error) => reject(error);
      });
    },
    truncate(str, length) {
      return str && str.length > length ? str.slice(0, length) + "..." : str;
    },
    removerColaboradorSelecionado(index) {
      this.colaboradoresSelecionados.splice(index, 1);
    },
    copiarTexto(texto) {
      navigator.clipboard
        .writeText(texto)
        .then(() => {})
        .catch((err) => {
          console.error("Erro ao copiar:", err);
        });
    },
    getStatusCor(status) {
      switch (status) {
        case "PARQUE DAS FLORES":
          return "orange darken-2";
        case "CEMITERIO PREVIDA":
          return "blue lighten-1";
        case "MEMORIAL PARQUE MACEIÓ":
          return "green lighten-1";
        case "PARQUE DO AGRESTE":
          return "cyan lighten-1";
        case "PREVIDA":
          return "blue lighten-1";
        case "A FLOR DO CAFÉ":
          return "purple lighten-1";
        default:
          "success";
      }
    },
    getStatusDisparoCor(status) {
      switch (status) {
        case true:
          return "green darken-1";
        case false:
          return "red";
      }
    },
    getStatus(status) {
      switch (status) {
        case true:
          return "ATIVO";
        case false:
          return "DESATIVADO";
      }
    },
    editarRegra(item) {
      console.log(item);
      const indeterminateTemp = item.data_final === null ? true : false;
      this.regra = {
        id: item.mensageria.id,
        formadisparo: item.mensageria_colaborador.forma_disparo,
        mensagem: item.mensageria.mensagem,
        anexos: item.mensageria_colaborador.anexos || null,
        horario: item.mensageria.horario,
        data_inicial: item.mensageria.data_inicial,
        data_final: item.mensageria.data_final,
        indeterminate: indeterminateTemp,
        status: item.mensageria.status,
        idMensageria: item.mensageria_colaborador.id,
        empresa: item.mensageria_colaborador.empresa,
        labelBotao1: item.mensageria_colaborador.labelBotao1,
        tipoBotao1: item.mensageria_colaborador.tipoBotao1,
        linkBotao1: item.mensageria_colaborador.linkBotao1,
        labelBotao2: item.mensageria_colaborador.labelBotao2,
        tipoBotao2: item.mensageria_colaborador.tipoBotao2,
        linkBotao2: item.mensageria_colaborador.linkBotao2,
        labelBotao3: item.mensageria_colaborador.labelBotao3,
        tipoBotao3: item.mensageria_colaborador.tipoBotao3,
        linkBotao3: item.mensageria_colaborador.linkBotao3,
        labelBotao4: item.mensageria_colaborador.labelBotao4,
        tipoBotao4: item.mensageria_colaborador.tipoBotao4,
        linkBotao4: item.mensageria_colaborador.linkBotao4,
      };
      this.showEditar = true;
      if (
        this.regra.labelBotao1 ||
        this.regra.labelBotao2 ||
        this.regra.labelBotao3 ||
        this.regra.labelBotao4
      ) {
        this.showBotoes = true;
      }

      // Verificar se existe um anexo como URL
      if (
        this.regra.anexos &&
        typeof this.regra.anexos === "string" &&
        this.regra.anexos.startsWith("http")
      ) {
        this.isExistingAttachment = true;
        this.existingAttachmentUrl = this.regra.anexos;
      } else {
        this.isExistingAttachment = false;
        this.existingAttachmentUrl = null;
      }

      this.colaboradoresSelecionados =
        item.mensageria_colaborador.mensageria_colaborador_pessoa.map(
          (colaborador) => colaborador.colaborador
        );
    },
    clear_atualizacao() {
      this.consultar_regras();
      this.showEditar = false;

      this.$refs.form.reset();
      this.colaboradoresSelecionados = [];
      this.isExistingAttachment = false;
      this.existingAttachmentUrl = null;
      this.$nextTick(() => {
        this.regra.indeterminate = false;
        this.regra.formadisparo = "";
        this.regra.data_final = "";
        this.regra.status = true;
        this.regra.id = 0;
        this.regra.anexos = null;
      });
    },
    handleStartDateSelection() {
      this.regra.data_inicial = this.convertDate(
        this.localSelectedStartDateISO
      );
      this.isStartDatePickerOpen = false;
    },

    handleEndDateSelection() {
      this.regra.data_final = this.convertDate(this.localSelectedEndDateISO);
      this.isEndDatePickerOpen = false;
    },
    convertDate(dateString, format = "iso") {
      if (!dateString) return "";

      if (format === "iso") {
        // Verifica se a string está no formato ISO completo (contém 'T')
        if (dateString.includes("T")) {
          dateString = dateString.split("T")[0]; // Remove a parte do horário
        }

        // Converte de ISO (YYYY-MM-DD) para BR (DD/MM/YYYY)
        const [year, month, day] = dateString.split("-");
        return `${day}/${month}/${year}`;
      } else if (format === "br") {
        // Converte de BR (DD/MM/YYYY) para ISO (YYYY-MM-DD)
        const [day, month, year] = dateString.split("/");
        return `${year}-${month}-${day}`;
      }

      return dateString; // Retorna a string original se o formato não for reconhecido
    },
    async adiciona_regra() {
      const valid = this.$refs.form.validate();
      if (!valid) {
        return;
      }
      this.loadingCreate = true;
      let arquivoBase64 = "";
      if (this.regra.anexos) {
        await this.fileToBase64(this.regra.anexos).then((base64) => {
          arquivoBase64 = base64;
        });
      }

      // Formatar os dados conforme a estrutura necessária
      const dadosFormatados = {
        mensageria: {
          horario: this.regra.horario,
          data_inicial: this.regra.data_inicial,
          data_final: this.regra.indeterminate
            ? this.regra.data_final
            : this.regra.data_inicial,
          mensagem: this.regra.mensagem,
          status: this.regra.status,
          tipo: "colaborador",
        },
        mensageria_colaborador: {
          empresa: this.regra.empresa,
          forma_disparo: this.regra.formadisparo,
          anexos: arquivoBase64 || "",
          labelBotao1: this.regra.labelBotao1,
          tipoBotao1: this.regra.tipoBotao1,
          linkBotao1: this.regra.linkBotao1,
          labelBotao2: this.regra.labelBotao2,
          tipoBotao2: this.regra.tipoBotao2,
          linkBotao2: this.regra.linkBotao2,
          labelBotao3: this.regra.labelBotao3,
          tipoBotao3: this.regra.tipoBotao3,
          linkBotao3: this.regra.linkBotao3,
          labelBotao4: this.regra.labelBotao4,
          tipoBotao4: this.regra.tipoBotao4,
          linkBotao4: this.regra.linkBotao4,
          mensageria_colaborador_pessoa: this.colaboradoresSelecionados.map(
            (colaborador) => ({
              colaborador: {
                id: colaborador.id,
              },
            })
          ),
        },
      };
      if (this.$refs.form.validate()) {
        mensageria
          .salvar_regrav2(dadosFormatados)
          .then((response) => {})
          .catch((e) => {})
          .finally(() => {
            this.consultar_regras();
            this.clear_atualizacao();
            this.valid = false;
            this.loadingCreate = false;
          });
      }
    },
    consultar_regras() {
      mensageria
        .lista_regrasv2("colaborador")
        .then((response) => {
          this.listaRegras = response.data;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {});
    },
    consultar_grupo_colaboradores() {
      rh.lista_grupos_colaboradorores("Mensageria", true).then((response) => {
        this.listaGruposColaborador = response.data;
      });
    },
    async atualizar_regra(item) {
      this.loadingUpdate = true;
      let arquivoBase64 = "";

      // Se for um anexo existente (URL), mantém a URL original
      if (this.isExistingAttachment && this.existingAttachmentUrl) {
        arquivoBase64 = this.existingAttachmentUrl;
      }
      // Se for um novo arquivo, converte para base64
      else if (this.regra.anexos && typeof this.regra.anexos !== "string") {
        await this.fileToBase64(this.regra.anexos).then((base64) => {
          arquivoBase64 = base64;
        });
      }
      // Formatar os dados conforme a estrutura necessária
      const dadosFormatados = {
        mensageria: {
          id: item.id,
          horario: this.regra.horario,
          data_inicial: this.regra.data_inicial,
          data_final: this.regra.indeterminate
            ? this.regra.data_final
            : this.regra.data_inicial,
          mensagem: this.regra.mensagem,
          status: this.regra.status,
          tipo: "colaborador",
        },
        mensageria_colaborador: {
          id: item.idMensageria,
          empresa: this.regra.empresa,
          labelBotao1: this.regra.labelBotao1,
          tipoBotao1: this.regra.tipoBotao1,
          linkBotao1: this.regra.linkBotao1,
          labelBotao2: this.regra.labelBotao2,
          tipoBotao2: this.regra.tipoBotao2,
          linkBotao2: this.regra.linkBotao2,
          labelBotao3: this.regra.labelBotao3,
          tipoBotao3: this.regra.tipoBotao3,
          linkBotao3: this.regra.linkBotao3,
          labelBotao4: this.regra.labelBotao4,
          tipoBotao4: this.regra.tipoBotao4,
          linkBotao4: this.regra.linkBotao4,
          forma_disparo: this.regra.formadisparo,
          anexos: arquivoBase64 || "",
          mensageria_colaborador_pessoa: this.colaboradoresSelecionados.map(
            (colaborador) => ({
              colaborador: {
                id: colaborador.id,
              },
            })
          ),
        },
      };

      if (this.$refs.form.validate()) {
        mensageria
          .salvar_regrav2(dadosFormatados)
          .then((response) => {})
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.consultar_regras();
            this.clear_atualizacao();
            this.valid = false;
            this.loadingUpdate = false;
          });
      }
      this.loadingUpdate = false;
    },
    // Obter referência do textarea
    getTextarea() {
      // Tenta encontrar o textarea baseado no tipo de disparo
      if (this.regra.formadisparo === "SMS") {
        return this.$refs.mensagemTextareaSMS?.$el?.querySelector("textarea") ||
               this.$refs.mensagemTextareaSMS;
      } else if (this.regra.formadisparo === "WhatsApp") {
        return this.$refs.mensagemTextareaWhatsApp?.$el?.querySelector("textarea") ||
               this.$refs.mensagemTextareaWhatsApp;
      }
      return null;
    },
    // Formatar texto (negrito, itálico, sublinhado)
    formatar(tipo) {
      const textarea = this.getTextarea();
      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      // Se não há texto selecionado, não faz nada
      if (start === end) return;

      const texto = this.regra.mensagem || "";
      const selecionado = texto.slice(start, end);

      // Define os marcadores por tipo
      const markers = {
        bold: "*",
        italic: "_",
        underline: "~",
      };

      const m = markers[tipo];

      let novo = selecionado;

      // Se já está formatado, remove a formatação
      if (selecionado.startsWith(m) && selecionado.endsWith(m)) {
        novo = selecionado.substring(1, selecionado.length - 1);
      } else {
        // Senão, adiciona a formatação
        novo = `${m}${selecionado}${m}`;
      }

      // Aplica a mudança no texto
      this.regra.mensagem = texto.slice(0, start) + novo + texto.slice(end);

      // Mantém a seleção após a formatação
      this.$nextTick(() => {
        textarea.focus();
        textarea.selectionStart = start;
        textarea.selectionEnd = start + novo.length;
      });
    },
    // Métodos para o emoji picker
    async toggleEmojiPicker() {
      // Carrega o emoji picker se ainda não foi carregado
      await loadEmojiPicker();
    },
    onEmojiClick(event) {
      // Insere o emoji na posição atual do cursor ou no final do texto
      const emoji = event.detail.unicode;
      if (this.regra.mensagem) {
        this.regra.mensagem += emoji;
      } else {
        this.regra.mensagem = emoji;
      }
      // Fecha o emoji picker após selecionar um emoji
      this.showEmojiPicker = false;
    },
  },
};
</script>

<style scoped>
.emoji-picker-container {
  position: relative;
  z-index: 9999;
}

.card-section {
  border-radius: 12px;
}

.section-header {
  padding: 16px 20px;
  border-radius: 12px 12px 0 0;
}

.v-btn {
  text-transform: none !important;
  letter-spacing: 0.5px;
  font-weight: 500 !important;
  border-radius: 8px;
}

.v-progress-circular {
  margin: 1rem;
}

.custom-gray-background {
  height: 90px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto !important;
  margin: -12px;
}

.v-menu__content {
  box-shadow: none !important;
  top: 4px !important;
}

.justify-center {
  justify-content: center;
}

.gray-row {
  background-color: rgb(71 130 180);
}

.cor-row {
  background-color: rgb(231 244 255);
  transition: none !important;
}

.linha {
  font-size: 11px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.no-hover-effect.v-data-table tbody tr:hover {
  color: #3055a4;
}

.card-container {
  display: flex;
  justify-content: space-around;
}
</style>
